module.exports = __webpack_public_path__ + "static/media/editStroke.81e759ae.svg";